import React from 'react';

const {
  Provider : SwapiServiceProvider,
  Consumer : SwapiServiceConsumer
} = React.createContext();

export {
  SwapiServiceProvider,
  SwapiServiceConsumer
};



// WEBPACK FOOTER //
// ./src/components/swapi-service-context/swapi-service-context.js